<template>
  <header class="topbar">
    <div v-if="loading" class="topbar__status">Cargando...</div>
    <div v-else-if="error" class="topbar__status topbar__status--error">
      No se pudo cargar la información del parque
    </div>
<template v-else>
  <div class="topbar__park-info">
    <h2 class="topbar__park-name">{{ park.name }}</h2>
    <span class="topbar__park-location">{{ park.city }}, {{ park.state }}</span>
  </div>

    <div class="topbar__right">
    <AlertsChip
      :alerts="alerts"
      @alert-action="$emit('alert-action', $event)"
      @alert-dismiss="$emit('alert-dismiss', $event)"
      @view-all="$emit('view-all-alerts')"
    />

    <div v-if="weather" class="topbar__weather">
      <span v-if="periodLabel" class="topbar__period">{{ periodLabel }}</span>
      <span class="mdi topbar__weather-icon" :class="weather.icon"></span>
      <span class="topbar__weather-temp">{{ weather.temperature }}°C</span>
    </div>

    <NotificationBell :park-id="park?.id" />
  </div>
</template>
  </header>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import NotificationBell from '@/components/Global/NotificationBell.vue'
import { getParks } from '@/services/parks'
import { getWeather } from '@/services/weather'
import AlertsChip from './AlertsChip.vue'

const park = ref(null)
const weather = ref(null)
const loading = ref(true)
const error = ref(false)
const props = defineProps({
  park: { type: Object, default: null },
  period: { type: Object, default: null },
  loading: { type: Boolean, default: false },
  alerts: { type: Array, default: () => [] },
})

defineEmits(['alert-action', 'alert-dismiss', 'view-all-alerts'])

const MONTHS = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']

const periodLabel = computed(() => {
  if (!props.period) return ''
  return `${MONTHS[props.period.month - 1]} ${props.period.year}`
})

onMounted(async () => {
  try {
    // Por ahora tomamos el primer parque de la lista.
    // Cuando tengamos selección de parque activo, esto cambia a getParkById(selectedId).
    const parks = await getParks()
    park.value = parks[0]

    if (park.value?.latitude && park.value?.longitude) {
      weather.value = await getWeather(park.value.latitude, park.value.longitude)
    }
  } catch (e) {
    error.value = true
  } finally {
    loading.value = false
  }
})
</script>

<style scoped>
.topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  background: var(--side-panel);
  border-left: 1px solid var(--border-subtle);
}

.topbar__park-info {
  display: flex;
  align-items: baseline;
  gap: 0.6rem;
}

.topbar__park-name {
  font-family: var(--font-display);
  font-size: 1.1rem;
  font-weight: 500;
  color: var(--text-primary);
}

.topbar__park-location {
  font-size: 0.85rem;
  color: var(--text-secondary);
}

.topbar__weather {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  color: var(--text-secondary);
}

.topbar__weather-icon {
  font-size: 1.2rem;
}

.topbar__weather-temp {
  font-family: var(--font-mono);
  font-size: 0.9rem;
}

.topbar__status {
  font-size: 0.85rem;
  color: var(--text-secondary);
}

.topbar__status--error {
  color: var(--accent-red);
}
.topbar__period{
  margin-right: 0.9rem;
  font-size: 0.9rem;
}
.topbar__notif {
  position: relative;
  display: flex;
  color: var(--text-secondary);
  font-size: 1.1rem;
}

.topbar__notif-badge {
  position: absolute;
  top: -6px;
  right: -8px;
  background: var(--accent-blue);
  color: white;
  font-size: 0.6rem;
  font-family: var(--font-mono);
  padding: 0 4px;
  border-radius: 8px;
  min-width: 14px;
  text-align: center;
}

.topbar__notif-badge--critical {
  background: var(--accent-red);
}

.topbar__right {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}
</style>